// extracted by mini-css-extract-plugin
export default {"container":"Terms_container__roK01","heading":"Terms_heading__NODmy","termsbackground":"Terms_termsbackground__aABPj"};